import { utils } from '@ims/1edtech-frontend-common'
import { TOKENS_STORAGE_KEY } from '../constants'
import { dataSelector } from './selectors'

export const setTokens = (response: any) =>
  utils.localStorage.setLocalItem(TOKENS_STORAGE_KEY, dataSelector(response))

export const getTokens = () =>
  utils.localStorage.getLocalItem(TOKENS_STORAGE_KEY)

export const getAccessToken = () => localStorage.getItem('accessToken');

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem('accessToken', accessToken);
};

export const removeAccessToken = () => {
  localStorage.removeItem('accessToken');
};
